/**
 * Auth store — manages current user session via Zustand.
 */

import { create } from 'zustand'
import { api, setToken, setRefreshToken, clearToken } from '../lib/api'

interface User {
  id: string
  name: string
  email: string
  role: 'admin' | 'manager' | 'employee'
}

interface AuthState {
  user: User | null
  loading: boolean
  error: string | null
  login: (token: string, refreshToken?: string) => Promise<void>
  logout: () => void
  fetchMe: () => Promise<void>
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  loading: false,
  error: null,

  login: async (token: string, refreshToken?: string) => {
    setToken(token)
    if (refreshToken) setRefreshToken(refreshToken)
    set({ loading: true, error: null })
    try {
      const user = await api.getMe()
      set({ user: user as User, loading: false })
    } catch (err) {
      clearToken()
      set({ error: 'Login failed', loading: false, user: null })
    }
  },

  logout: () => {
    clearToken()
    set({ user: null })
  },

  fetchMe: async () => {
    set({ loading: true })
    try {
      const user = await api.getMe()
      set({ user: user as User, loading: false })
    } catch {
      set({ user: null, loading: false })
    }
  },
}))
